import store from '@/state/store.js';
import { EventBus } from '@/services/event-bus';
import { axiosUserRequest } from '@/helpers/authservice/axios';

export const state = {
    settings: [],
};

export const getters = {
    getByProfileId(state) {
        return id => state.settings.find(setting => setting.profile_id === id);
    }
}

export const mutations = {
    pushOrReplace(state, data) {
        const setting = state.settings.find(setting => setting.profile_id === data.profile_id);

        if (setting) {
            const index = state.settings.indexOf(setting);

            state.settings.splice(index, 1, data);
        } else {
            state.settings.push(data);
        }
	},

    clear(state) {
        state.settings = [];
    }
};

export const actions = {
    get({commit}, id) {
        return axiosUserRequest({ method: 'get', url: `/v1/profiles/${id}/settings`}).then(({data}) => {
			commit('pushOrReplace', data);
		});
    },

    update(context, data) {
        return axiosUserRequest({ method: 'put', url: `/v1/profiles/${data.profile_id}/settings`, data });
    },

    clear({commit}) {
        commit('clear');
    }
};

EventBus.$on('logout', () => {
    store.dispatch('profileSettings/clear');
});
